module.exports = __webpack_public_path__ + "static/media/lucy.3e678e5b.jpeg";